import React from 'react';
interface FallbackProps {
  error?: Error;
}
function JournalEntriesErrorView({ error }: FallbackProps) {
  return (
    <div className="report-view">
      <div className="forecast-layout">
        <div className="card forecast-view h-50">
          <h2>Journals is not active for this locations</h2>
          <pre style={{ display: process.env.NODE_ENV === 'development' ? 'block' : 'none' }}>{error?.message}</pre>
        </div>
      </div>
    </div>
  );
}

export default JournalEntriesErrorView;
